export const AidaptiveImpressionPixel = ({ url }: { url: string }) => (
  // eslint-disable-next-line @next/next/no-img-element
  <img
    loading="lazy"
    src={url}
    alt=""
    aria-hidden="true"
    className="pointer-events-none"
    style={{
      opacity: 0.001,
      display: 'block',
      position: 'relative',
      margin: '-1px 0 0 0',
      height: '1px',
      width: '1px',
    }}
  />
);
